import { VoteType } from "api/vote";
import Participants from "containers/Participants";
import useBoundStore from "store";

interface TimelineEventParticipantsVotesProps {
  onBack?: () => void;
}

export default function TimelineEventParticipantsVotes(props: TimelineEventParticipantsVotesProps): JSX.Element | null {
  const { onBack } = props;
  const selected = useBoundStore((state) => state.selected);

  if (selected.timelineEvent?.votes) {
    const participantsVotes = selected.timelineEvent.votes.filter((vote) => vote.type === VoteType.PARTICIPATING);

    return <Participants onBack={onBack} users={selected.timelineEvent.users ?? []} votes={participantsVotes} />;
  }

  return null;
}
